import { toContext } from 'ol/render';
import LineString from 'ol/geom/LineString';
import Polygon from 'ol/geom/Polygon';
import Point from 'ol/geom/Point';
// default WMS size
const WIDTH = 36;
const HEIGHT = 20;
export const getLegendCanvasItemFromStyle = (feature, style) => {
    if (!feature || !style)
        return null;
    const canvas = document.createElement('canvas');
    canvas.id = 'legend';
    canvas.width = WIDTH;
    canvas.height = HEIGHT;
    canvas.style.position = 'absolute';
    const vectorContext = toContext(canvas.getContext('2d'), { size: [WIDTH, HEIGHT] });
    const styles = (typeof style === 'function' ? style(feature, 1) : style);
    // remove text styles for legend
    const filteredStyles = styles.filter((style) => !style.getText());
    const type = feature.getGeometry()?.getType();
    switch (type) {
        case 'Polygon':
        case 'MultiPolygon': {
            filteredStyles.forEach((style) => {
                vectorContext.setStyle(style);
                vectorContext.drawGeometry(new Polygon([
                    [
                        [4, 4],
                        [4, 16],
                        [32, 16],
                        [32, 4],
                        [4, 4],
                    ],
                ]));
            });
            break;
        }
        case 'LineString':
        case 'MultiLineString': {
            filteredStyles.forEach((style) => {
                vectorContext.setStyle(style);
                vectorContext.drawGeometry(new LineString([
                    [4, 6],
                    [12, 10],
                    [20, 6],
                    [32, 10],
                ]));
            });
            break;
        }
        case 'Point':
        case 'MultiPoint': {
            filteredStyles.forEach((style) => {
                vectorContext.setStyle(style);
                vectorContext.drawGeometry(new Point([18, 10]));
            });
            break;
        }
    }
    return canvas;
};
//# sourceMappingURL=getLegendCanvasItemFromStyle.js.map